import React, { useState } from "react";
import { Link } from "react-router-dom";
import CtaLineLeft from "../../../assets/icons/line-vector-left.svg";
import CtaLineRight from "../../../assets/icons/line-vector-right.svg";
import { TypeAnimation } from "react-type-animation";

export const BusinessHeroSection = () => {
  const [bgImage, setBgImage] = useState("./assets/bg.jpg");
  return (
    <div
      className="relative"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundPosition: "center 100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: "background-image 1s ease-out",
        // backgroundColor: '#142528',
      }}
    >
      <div className="flex flex-col items-center pt-[4rem] pb-[20rem] gap-[1rem] md:gap-[1rem] ">
        <h1 className="text-white leading-tight md:leading-[4rem] text-[1.5rem] sm:text-[2.2rem] md:text-[3rem] lg:text-[4rem] font-[700] w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] text-center font-[Montserrat] m-0">
          Unlock tools to Simplify your Business{" "}
          <span className="text-[#32ae4c]">
            <TypeAnimation
              sequence={[
                "finances",
                500,
                "growth",
                500,
                "success",
                500,
                "journey",
                500,
                "stability",
                500,
              ]}
              repeat={Infinity}
            />
          </span>
        </h1>

        <p className="text-white m-0 w-[90%] sm:w-[70%] md:w-[45%] text-[0.9rem] sm:text-[1.1rem] md:text-[1.2rem] text-center">
          Manage your payments, collections, and transfers effortlessly, all
          from one platform.
        </p>

        <div className="flex  items-center gap-[2rem]">
          <img src={CtaLineLeft} alt="" className="hidden md:block " />

          <button className="text-[0.8rem] py-[0.4rem] md:py-[0.8rem] px-4 md:px-8 text-base border-none rounded-[30px] bg-[#32AE4C] text-white cursor-pointer hover:bg-[#fff] hover:text-[#32AE4C]">
            <Link to="https://business.vant.ng/signup">Get Started</Link>
          </button>

          <img src={CtaLineRight} alt="" className="hidden md:block" />
        </div>
      </div>
    </div>
  );
};
